import CustomTable from "components/shared/table";
import { InputBatchConfigFormat } from "pages/geoscape-batch/types";
import { Dispatch, SetStateAction, useMemo } from "react";
import { buildInputColumns } from "./columns-row";
import { addIndex } from "./utils";

interface MappingTableInputProps {
  inPutParameters: InputBatchConfigFormat[];
  setInPutParameters: Dispatch<SetStateAction<InputBatchConfigFormat[]>>;
}

type IndexedInputBatchConfigFormat = InputBatchConfigFormat & { index: number };

const MappingTableInput = ({
  inPutParameters,
  setInPutParameters,
}: MappingTableInputProps) => {
  const columns = useMemo(
    () => buildInputColumns({ setInPutParameters }),
    [setInPutParameters],
  );

  return (
    <div className="flex flex-col items-center w-full mt-4">
      <CustomTable
        rows={addIndex(inPutParameters)}
        columns={columns}
        isLoading={false}
        overlayText=""
        getRowId={(row: IndexedInputBatchConfigFormat) => String(row.index)}
      />
    </div>
  );
};

export default MappingTableInput;
